export default {
    path : "warehouse-carrier-focus",
    name : "warehouse-carrier-focus",
    meta : {
        title : "关注载体"
    },
    component: () => import('@/pages/warehouse/focusCarrier/Index'),
    redirect: {
        name : "warehouse-carrier-focus-whole"
    },
    children: [
        {
            path: 'all',
            name: 'warehouse-carrier-focus-whole',
            meta: {
                title: '仓库载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'recent',
            name: 'warehouse-carrier-focus-recent',
            meta: {
                title: '仓库载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'atme',
            name: 'warehouse-carrier-focus-atme',
            meta: {
                title: '仓库载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'meat',
            name: 'warehouse-carrier-focus-meat',
            meta: {
                title: '仓库载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'reply',
            name: 'warehouse-carrier-focus-reply',
            meta: {
                title: '仓库载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'search',
            name: 'warehouse-carrier-focus-search',
            meta: {
                title: '仓库载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'update',
            name: 'warehouse-carrier-focus-update',
            meta: {
                title: '仓库载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/warehouse/focuscarrier/index.js